import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react';
import { Dialog } from 'primereact/dialog';
import { CCol, CFormLabel, CRow } from '@coreui/react';
import { useReport } from '../contexts/ReportContext';
import { useCompanySetting } from '../contexts/CompanySettingContext';

function ViewSingleReceiptReport({ receiptId, setReceiptId }) {
    const { singleReceiptReport } = useReport();
    const { currency } = useCompanySetting();

    const [receiptDetail, setReceiptDetail] = useState(null);
    const [hoveredProductId, setHoveredProductId] = useState(null);

    const fetchSingleReceipt = async () => {
        try {
            const receipt = await singleReceiptReport(receiptId);
            if (receipt.error === false) {
                setReceiptDetail(receipt.order);
            }
        } catch (error) {
            console.error('Error fetching single receipt report', error);
        }
    };

    useEffect(() => {
        if (receiptId) fetchSingleReceipt();
    }, [receiptId]);

    const handleClose = () => {
        setReceiptId(null);
    };

    return (
        <Dialog
            draggable={false}
            header={`Receipt Details`}
            visible={!!receiptId}
            style={{ width: '43vw' }}
            onHide={handleClose}
        >
            <div className='ps-3 pt-3 pe-3'>
                {
                    receiptDetail && (
                        <div>
                            <div className='border-bottom w-100'>
                                <CRow className='mb-3 w-50'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Receipt:</div>
                                        <CFormLabel className='w-50'>{receiptDetail.id}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-3 w-50'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Restaurant:</div>
                                        <CFormLabel className='w-50'>{receiptDetail.restaurantName}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-3 w-100'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Created On:</div>
                                        <CFormLabel className='w-50'>{receiptDetail.createdAt}</CFormLabel>
                                    </CCol>
                                    <CCol className='text-end'>
                                        <CFormLabel>{receiptDetail.createdBy}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-3 w-50'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Modified On:</div>
                                        <CFormLabel className='w-50'>{receiptDetail.updatedAt}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-3 w-50'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Status:</div>
                                        <CFormLabel>{receiptDetail.status}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-2 w-50'>
                                    <CCol className='d-flex w-100'>
                                        <div className='me-2 text-end w-50'>Table:</div>
                                        <CFormLabel>{receiptDetail.tableName}</CFormLabel>
                                    </CCol>
                                </CRow>
                                <CRow className='mb-3 w-100'>
                                    <CCol className='d-flex'>
                                        <div className='me-2 text-end w-50'>Payment:</div>
                                        <CFormLabel className='w-50'>{receiptDetail.payment_method ? `${receiptDetail.payment_method}` : ''}</CFormLabel>
                                    </CCol>
                                    <CCol className='text-end'>
                                        <CFormLabel>{receiptDetail.paymentBy ? receiptDetail.paymentBy : ''}</CFormLabel>
                                    </CCol>
                                </CRow>

                                {
                                    receiptDetail.splitBillMethods &&
                                    receiptDetail.splitBillMethods.length > 0 &&
                                    (
                                        <CRow className='mb-2 w-100'>
                                            <CCol className='d-flex px-0'>
                                                <div className='text-end' style={{ minWidth: "25%" }}></div>
                                                <table className="borderless-table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Payment Method</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {receiptDetail.splitBillMethods.map((method, index) => (
                                                            <tr key={method.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{method.payment_method_name}</td>
                                                                <td>{currency}{method.amount.toFixed(2)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </CCol>
                                        </CRow>
                                    )
                                }
                            </div>
                            <div className='mt-3 border-bottom'>
                                <CRow className='mb-1 w-50'>
                                    <CCol>
                                        <div className='me-2 text-end w-50'>Ordered items:</div>
                                    </CCol>
                                </CRow>
                                {
                                    receiptDetail.products &&
                                    receiptDetail.products.length > 0 &&
                                    (
                                        receiptDetail.products.map((product, index) => (
                                            <CRow className='mb-2' key={`${product.id}-${index}`}>
                                                <CCol>
                                                    <CFormLabel className='receipt_product_name w-100'>
                                                        {product.name} * {product.quantity} ({currency}{product.modified_price})
                                                    </CFormLabel>
                                                    {product.modifiers && product.modifiers.length > 0 && (
                                                        <ul className='product-modifier-list'>
                                                            {product.modifiers.map((modifier) => (
                                                                <li key={modifier.id}>
                                                                    {modifier.name} * {modifier.quantity} ({currency}{modifier.modified_price})
                                                                    {modifier.modifiers && modifier.modifiers.length > 0 && (
                                                                        <ul className='choice-modifier-list' style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                                                                            {modifier.modifiers.map((choiceMod) => (
                                                                                <li key={choiceMod.id}>
                                                                                    {choiceMod.name} * {choiceMod.quantity} ({currency}{choiceMod.modified_price})
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </CCol>
                                                <CCol className='text-end me-4 position-relative'>
                                                    <Icon
                                                        icon="akar-icons:info-fill"
                                                        className={hoveredProductId === `${product.id}-${product.quantity}-${product.relation_id}` ? 'hoveredProductId' : 'withoutHoveredProductId'}
                                                        onMouseEnter={() => setHoveredProductId(`${product.id}-${product.quantity}-${product.relation_id}`)}
                                                        onMouseLeave={() => setHoveredProductId(null)}
                                                    />
                                                    {hoveredProductId === `${product.id}-${product.quantity}-${product.relation_id}` && (
                                                        <div className='receipt_product_detail'>
                                                            <div className='mb-1 text-start'>
                                                                Created By {receiptDetail.createdBy} on {receiptDetail.createdAt}
                                                            </div>
                                                            <div className='text-start'>
                                                                Last Modified By {receiptDetail.updatedBy} on {receiptDetail.updatedAt}
                                                            </div>
                                                        </div>
                                                    )}
                                                </CCol>
                                            </CRow>
                                        ))
                                    )
                                }
                            </div>
                            <div className="mt-3 border-bottom">
                                <CRow>
                                    <CCol className="w-50">
                                        <CRow>
                                            <CCol className="d-flex w-100">
                                                <div className="me-2 text-end w-50">Total Price:</div>
                                                <CFormLabel>{currency}{receiptDetail.total}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol className="d-flex w-100">
                                                <div className="me-2 text-end w-50">Discount:</div>
                                                <CFormLabel>{currency}{receiptDetail.totalDiscountAmount}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol className="w-50">
                                        <CRow>
                                            <CCol className="d-flex w-100">
                                                <div className="me-2 text-end w-50">Change:</div>
                                                <CFormLabel>{currency}{receiptDetail.change}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol className="d-flex w-100">
                                                <div className="me-2 text-end w-50">Tip:</div>
                                                <CFormLabel>{currency}{receiptDetail.tip}</CFormLabel>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </div>
                            {
                                receiptDetail.status === 'paid' &&
                                receiptDetail.vatByCategory &&
                                receiptDetail.vatByCategory.length > 0 &&
                                (
                                    <div className="mt-3">
                                        <CRow className="mb-2 receipt_tax_rate">
                                            <CCol className='table_header_font'>
                                                <div>Category</div>
                                            </CCol>
                                            <CCol className='table_header_font'>
                                                <div>Tax rate</div>
                                            </CCol>
                                            <CCol className='table_header_font'>
                                                <div>Net</div>
                                            </CCol>
                                            <CCol className='table_header_font'>
                                                <div>VAT</div>
                                            </CCol>
                                            <CCol className='table_header_font'>
                                                <div>Gross</div>
                                            </CCol>
                                        </CRow>
                                        {
                                            receiptDetail.vatByCategory.map((category, index) => (
                                                <CRow
                                                    className={`mb-1 receipt_tax_rate ${index === receiptDetail.vatByCategory.length - 1 ? "table_header_font" : ""}`}
                                                    key={index}
                                                >
                                                    <CCol>
                                                        <CFormLabel>
                                                            {category.categoryName || "N/A"}
                                                        </CFormLabel>
                                                    </CCol>
                                                    <CCol>
                                                        <CFormLabel>
                                                            {category.taxRate || (index === receiptDetail.vatByCategory.length - 1 ? "" : "0.00%")}
                                                        </CFormLabel>
                                                    </CCol>
                                                    <CCol>
                                                        <CFormLabel>
                                                            {currency}
                                                            {category.netAmount || "0.00"}
                                                        </CFormLabel>
                                                    </CCol>
                                                    <CCol>
                                                        <CFormLabel>
                                                            {currency}
                                                            {category.vatAmount || "0.00"}
                                                        </CFormLabel>
                                                    </CCol>
                                                    <CCol>
                                                        <CFormLabel>
                                                            {currency}
                                                            {category.grossAmount || "0.00"}
                                                        </CFormLabel>
                                                    </CCol>
                                                </CRow>
                                            ))
                                        }
                                    </div>
                                )
                            }
                        </div>
                    )}
            </div>
        </Dialog>
    )
}

export default ViewSingleReceiptReport